import { defineComponent } from "vue";
import OptionBaseControl from "@/library/templates/default/controls/OptionBaseControl";
export default defineComponent({
  name: "RadioButtonList",
  extends: OptionBaseControl,
});
